/* eslint-disable react-hooks/exhaustive-deps */
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Button, Modal } from "react-bootstrap";
import peticionBack from "../../../libs/peticiones/peticionBack";
import { Loader, toaster } from "rsuite";
import InputForm from "../../../components/inputs/InputForm";
import { Folder } from "../../../types/filemanager/Folder";
import { useStore } from "../../../context/AppContext";

const formSchema = Yup.object().shape({
    name: Yup.string().required("Ingrese un nombre"),
});

export default function FormName({ children, selected, updateFolders, currFolder, controled }: 
    {children?: any, selected?: any, updateFolders: Function, currFolder?: Folder, controled?: [boolean, Dispatch<SetStateAction<boolean>>] }){
    let [modal, setModal] = useState<boolean>(false);
    if(controled) { [modal, setModal] = controled }
    const [loading, setLoading] = useState<boolean>(false);
    const { state } = useStore();

    const {
        handleSubmit,
        handleReset,
        handleBlur,
        setFieldValue,
        values,
        errors,
        touched,
    } = useFormik({
        initialValues: { name: "" },
        validationSchema: formSchema,
        onSubmit: (values) => save(),
        onReset: () => setModal(false),
    });

    function onChange({ target }: { target: any }) {
        setFieldValue(target.name, target.value);
    }

    async function save() {
        setLoading(true);
        const method = selected ? "PUT" : "POST";
        const endpoint = selected && selected.mimetype.toUpperCase() !== "CARPETA" ? "/file" :  "/folder";
        const props = {
            ...values,
            folder: currFolder?._id,
            propietary: state.user.credentials?._id
        }
        const res = await peticionBack(props, endpoint+(selected ? "/"+selected._id : ""), method, true, toaster);
        setLoading(false);
        if(res){
            // HACER PUSH FOLDER O FILE A CONTENT Y FOLDERS
            updateFolders(res, method === "PUT" ? 1 : 0);
            // updateFolders();
            handleReset(null);
            
        }
    }

    useEffect(()=>{
        if(modal && selected){
            setFieldValue("name", selected.name);
            setModal(true);
        }
    }, [modal]);
    
    return(
        <>
            {
                children ? children :
                <button className="opt-menu" type="button" onClick={()=>setModal(true)}>
                    <img src="/images/folder.svg" alt="new-folder" width="50"/>
                    <p className="">Nueva carpeta</p>
                </button> 
            }

            <Modal show={modal} onHide={() => setModal(false)} size="lg" centered scrollable={false} keyboard>
                <Modal.Header className="border-bottom-0 pb-0" closeButton></Modal.Header>
                <Modal.Body className="pt-0">
                    <form onSubmit={handleSubmit} onReset={handleReset}>
                        <InputForm
                            label={selected && selected.type !== "folder" ? "Nombre archivo" : "Nombre carpeta"}
                            name="name"
                            type="text"
                            value={values.name}
                            touched={touched.name}
                            error={errors.name}
                            onChangeMethod={onChange}
                            onBlurMethod={handleBlur}
                            required
                            autoFocus
                            handleFocus={(event: any) => event.target.select()}
                        />

                        <div className="d-grid gap-2 d-md-flex justify-content-md-around mt-3 mb-0">
                            <Button variant="danger" type="reset">Cancelar</Button>
                            <Button variant="success" type="submit">Guardar</Button>
                        </div>
                    </form>
                    { loading && <Loader backdrop center /> }
                </Modal.Body>
            </Modal>
        </>
    )
}